<div id="topStorageContent">
    <res-generic-grid #storagesGrid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
        [rowClassRules]="rowClassRules" [columnDefs]="storagesColumnDefs" [gridContext]="storagesGridContext"
        [rowSelection]="storagesSelection" [contextMenuOptions]="contextMenuOptions" [pagerVisible]="false"
        [onSelectionChanged]="onSelectionChanged" [hasContextMenuPermissions]="hasContextMenuPermissions"
        [pinnedTopRowData]="pinnedRowData" [rowDragManaged]="hasSystemStorageAddEditPermissions"
        [onRowDragEnd]="onRowDragEnd.bind(this)" [onRowDragLeave]="onRowDragLeave.bind(this)"
        [cellClickedCallback]="cellClickedCallback" [onRowClickedCallback]="indexRowClickedCallback.bind(this)">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <button type="button" class="secondary-button button-group" (click)="addNewStorage()"
            *ngIf="hasSystemStorageAddEditPermissions" data-automation-id="storage-settings-new-storage-button">
            <i class="fa fa-plus"></i>New Storage ...
        </button>
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'"
            class="primary-button button-group" *ngIf="hasSystemStorageAddEditPermissions" (click)="saveChanges()"
            [disabled]="isDisabled()">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            *ngIf="hasSystemStorageAddEditPermissions" class="secondary-button button-group" (click)="discardChanges()"
            [disabled]="isBusy || isDisabled()">Discard Changes</button>
    </ng-template>
</div>
<res-resizer #middleResizer anchor="bottom" resizingElementId="bottomStorageContent" secondElementId="topStorageContent"
    [collapsible]="true" [wideInputOnDrag]="true" [initSize]="30" [usePercentages]="true"
    [ellipsisExpander]="true"></res-resizer>
<div id="bottomStorageContent">
    <res-generic-grid #storageDetailsGrid [gridName]="'Storage Details'" [automationId]="detailsAutomationId"
        [(isBusy)]="isBusyDetails" [(isBusyMessage)]="isBusyMessageDetails" [columnDefs]="storageDetailsColumnDefs"
        [gridContext]="storageDetailsGridContext" [pagerVisible]="false">
    </res-generic-grid>
</div>